import { useRouter } from 'next/router';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import EfLink from '@elem/ui/ef-link';
import { message } from 'antd-v5';
import { LearnMoreList } from '../../common';
import css from './index.module.scss';
import { G_DATA } from './common';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { gtm } = useGlobal();
    const { locale = 'us' } = useRouter();
    const data = G_DATA[locale] || G_DATA['us'];

    const handleCopy = async (val: string) => {
        try {
            await navigator.clipboard.writeText(val);
            message.open({
                type: 'success',
                content: data.successCopy,
                style: {
                    position: 'relative',
                    top: 80,
                },
            });
        } catch (error) {
            message.open({
                type: 'error',
                content: data.errorCopy,
                style: {
                    position: 'relative',
                    top: 80,
                },
            });
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'get_support',
            button_name: data.phone,
        });
    };

    const handleOpenChat = (btnName: string) => {
        try {
            (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
            gtm.push({
                event: 'uaEvent',
                event_name: 'get_support',
                button_name: btnName,
            });
        } catch (error) {}
    };

    return (
        <div className={`support-module ${css['Support']}`} id="ContactUs">
            <EfSpec />
            <div className="support-title">{data.moduleTitle}</div>
            <div className="G-content">
                {!['it', 'es', 'tw', 'sa', 'br', 'mx'].includes(locale) && (
                    <div className="G-content-item G-content-phone">
                        <EfImg className="item-icon" pc="https://websiteoss.ecoflow.com/upload/image/1731555699807/phone.png" />
                        <div className="item-title">{data.phoneTitle}</div>
                        <EfLink
                            className="item-link support-link link-mobile"
                            href={`tel:${data.phone}`}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'get_support',
                                button_name: data.phone,
                            }}
                        >
                            {data.phone}
                        </EfLink>
                        <a className="item-link support-link link-pc" onClick={() => handleCopy(data.phone as string)}>
                            {data.phone}
                        </a>
                        <div className="item-desc">{data.serviceTime}</div>
                    </div>
                )}

                <div className="G-content-item G-content-email">
                    <EfImg className="item-icon" pc="https://websiteoss.ecoflow.com/upload/image/1731555699623/email.png" />
                    <div className="item-title">{data.emailTitle ?? 'Email'}</div>
                    <EfLink
                        className="item-link support-link"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'get_support',
                            button_name: `${data.emailText} >`,
                        }}
                        href={`mailto:${data.email}`}
                    >
                        {`${data.emailText} >`}
                    </EfLink>
                </div>
                {locale === 'jp' && (
                    <div className="G-content-item G-content-ai">
                        <EfImg className="item-icon" pc="https://websiteoss.ecoflow.com/upload/image/1764747798271/Group.png" />
                        <div className="item-title">{'Chat'}</div>
                        <EfLink
                            className="item-link support-link"
                            onClick={() => {
                                handleOpenChat('インテリジェントチャットへ');
                            }}
                        >
                            インテリジェントチャットへ＞
                        </EfLink>
                    </div>
                )}
            </div>
            {!['cn', 'tw', 'jp', 'kr', 'sa', 'br', 'mx'].includes(locale) && (
                <div className="G-community">
                    <div className="G-community-info">
                        <div className="G-community-title">{data.communityTitle}</div>
                        <div className="G-community-desc">{data.communityDesc}</div>
                        <EfLink
                            className="G-community-link support-link"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'get_support',
                                button_name: `${LearnMoreList[locale] || LearnMoreList['us']} >`,
                            }}
                            href={`https://www.ecoflow.com/${locale}/community`}
                            target="_blank"
                        >
                            {`${LearnMoreList[locale] || LearnMoreList['us']} >`}
                        </EfLink>
                    </div>
                    <EfImg
                        className="G-community-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1731563429215/G-pc.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1731563429432/G-pad.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1731563429043/G-h5.jpg"
                    />
                </div>
            )}
        </div>
    );
}
